export const lightTheme = {
  name: 'light',

  colors: {
    // Backgrounds
    background: '#F7F8F5',
    backgroundSecondary: '#EEF2EC',
    surface: '#FFFFFF',
    sidebar: '#EEF2EC',

    // Text
    textPrimary: '#1A211C',
    textSecondary: '#3D4A42',
    textMuted: '#6B7A71',
    textInverse: '#FFFFFF',

    // Borders
    borderSubtle: '#E8EEE9',
    borderDefault: '#D5DDD6',
    borderStrong: '#B7C4BB',

    // Brand / Actions — Ireland green + Chile red
    primary: '#0B6E4F',
    primaryHover: '#095C42',
    accent: '#C8102E',
    accentHover: '#A50D26',
    success: '#0B6E4F',
    warning: '#D97706',
    error: '#C8102E',
  },

  typography: {
    fontFamily: 'Poppins, system-ui, sans-serif',

    h1: {
      fontSize: '2rem',
      fontWeight: 'bold',
      lineHeight: 1.2,
      color: 'textPrimary',
    },

    h2: {
      fontSize: '1.75rem',
      fontWeight: 'bold',
      lineHeight: 1.3,
      color: 'textPrimary',
    },

    h3: {
      fontSize: '1.5rem',
      fontWeight: 'regular',
      lineHeight: 1.4,
      color: 'textPrimary',
    },

    h4: {
      fontSize: '1.25rem',
      fontWeight: 'regular',
      lineHeight: 1.4,
      color: 'textPrimary',
    },

    h5: {
      fontSize: '1rem',
      fontWeight: 'regular',
      lineHeight: 1.5,
      color: 'textPrimary',
    },

    h6: {
      fontSize: '0.875rem',
      fontWeight: 'regular',
      lineHeight: 1.5,
      color: 'textPrimary',
    },

    subtitle: {
      fontSize: '1.125rem',
      fontWeight: 'regular',
      lineHeight: 1.6,
      color: 'textSecondary',
    },

    body1: {
      fontSize: '1rem',
      fontWeight: 'regular',
      lineHeight: 1.6,
      color: 'textSecondary',
    },

    body2: {
      fontSize: '0.875rem',
      fontWeight: 'regular',
      lineHeight: 1.5,
      color: 'textSecondary',
    },

    caption: {
      fontSize: '0.75rem',
      fontWeight: 'regular',
      lineHeight: 1.4,
      color: 'textMuted',
    },

    jumbo: {
      fontSize: '3.5rem',
      fontWeight: 'bold',
      lineHeight: 1.1,
      color: 'textPrimary',
    },
  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px',
  },

  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },

  shadows: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 4px 6px rgba(0,0,0,0.1)',
    lg: '0 10px 15px rgba(0,0,0,0.15)',
  },
}
